export const poolOptions = [];

export const dropLiveOptions = [
  { value: 'DROP', text: 'Drop' },
  { value: 'LIVE', text: 'Live' }
];
